<div class="dialog__fullscreen">
  <div class="dialog__header">
    <div class="dialog__header-content">
      <h2>{{ editMode ? 'Edit iCal Feed' : 'Add External iCal Feed' }}</h2>
      <button type="button" (click)="onCancel()" class="dialog__close-button" data-element="cancel-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog__content">
    <div class="dialog__content-wrapper">
      <div *ngIf="loadingInitialData" class="flex justify-center items-center py-4">
        <mat-spinner diameter="32"></mat-spinner>
      </div>

      <form *ngIf="!loadingInitialData" [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col space-y-6">
        <!-- iCal Section -->
        <div class="p-2">
          <h3 class="text-md font-medium text-night mb-4">iCal Information</h3>

          <div class="flex flex-col space-y-4">
            <div class="flex flex-col space-y-1">
              <label for="url" class="text-sm font-medium text-night">URL</label>
              <input
                id="url"
                type="url"
                formControlName="url"
                class="px-3 py-2 border border-smoke rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="https://"
                data-element="ical-url-input" />
              <div *ngIf="form.get('url').touched && form.get('url').errors?.pattern" class="text-xs text-danger">
                Please enter a valid URL starting with http:// or https://
              </div>
            </div>

            <div *ngIf="form.get('url').value || editMode" class="flex flex-col space-y-1">
              <label for="name" class="text-sm font-medium text-night">iCal Nickname</label>
              <span class="text-xs text-night-lighter">A recognizable name for this calendar feed. Useful if you're importing multiple.</span>
              <input
                id="name"
                type="text"
                formControlName="name"
                class="px-3 py-2 border border-smoke rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="Feed name"
                data-element="ical-name-input" />
            </div>
          </div>
        </div>

        <!-- Host Section -->
        <div class="p-2">
          <h3 class="text-md font-medium text-night mb-2">Host Information</h3>
          <p class="text-xs text-night mb-4">This information will be used in guest messaging templates and AI.</p>

          <div class="flex flex-col md:flex-row md:space-x-4">
            <div class="flex flex-col space-y-1 w-full">
              <label for="first_name" class="text-sm font-medium text-night">Host First Name</label>
              <input
                id="first_name"
                type="text"
                formControlName="first_name"
                class="px-3 py-2 border border-smoke rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="First name"
                data-element="ical-first-name-input" />
            </div>

            <div class="flex flex-col space-y-1 w-full mt-4 md:mt-0">
              <label for="last_name" class="text-sm font-medium text-night">Host Last Name</label>
              <input
                id="last_name"
                type="text"
                formControlName="last_name"
                class="px-3 py-2 border border-smoke rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="Last name"
                data-element="ical-last-name-input" />
            </div>
          </div>
        </div>

        <div class="flex justify-end space-x-3 mt-4">
          <sbnb-button
            *ngIf="!loading"
            type="secondary"
            (clicked)="onCancel()"
            data-element="cancel-button"
            label="Cancel"></sbnb-button>
          <sbnb-button
            type="primary"
            [disabled]="!form.valid || loading"
            (clicked)="onSubmit()"
            data-element="submit-button"
            [label]="loading ? (editMode ? 'Updating...' : 'Adding...') : (editMode ? 'Update Feed' : 'Add Feed')"></sbnb-button>
        </div>
      </form>
    </div>
  </div>
</div>
